import { useCallback, useState } from 'react';

export type UseStepperProps = {
  stepsCount: number;
  onComplete: () => void;
};

export type UseStepperResponse = {
  step: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
};

export const useStepper = ({ stepsCount, onComplete }: UseStepperProps): UseStepperResponse => {
  const [step, setStep] = useState<number>(0);

  const goToNextStep = useCallback((): void => {
    if (step < stepsCount - 1) {
      setStep(step + 1);
    } else {
      onComplete();
    }
  }, [onComplete, step, stepsCount]);

  const goToPrevStep = useCallback((): void => {
    if (step === 0) return;

    setStep(step - 1);
  }, [step]);

  return {
    step,
    goToNextStep,
    goToPrevStep,
  };
};
